import React, { useState } from 'react';

export default function SwaggerUI(): JSX.Element {
  const [iframeSrc] = useState<string>(process.env.REACT_APP_SWAGGER as string);
  return (
    <React.Fragment>
      <div style={{ width: '100%', height: '100vh' }}>
        <iframe
          key='iframeSwagger'
          src={iframeSrc}
          title='Swagger website'
          style={{ width: '100%', height: '100%' }}></iframe>
        ;
      </div>
    </React.Fragment>
  );
}
